import React from 'react';
import { Text, VStack } from '@chakra-ui/react';

const CheckoutBugNoticeText = ({
  fontSize = 'sm',
  color = 'gray.400',
  showPaymentHint = true,
  ...textProps
}) => (
  <VStack align="stretch" spacing={2} {...textProps}>
    <Text fontSize={fontSize} color={color} lineHeight="tall">
      Se hai prenotato{' '}
      <Text as="span" fontWeight="600" color="gray.300">
        più settimane del Centro Estivo in un solo ordine
      </Text>
      , può essere successo che il sito le abbia tutte confermate, ma che sulla
      carta sia stato addebitato solo l&apos;importo di una settimana.
    </Text>
    <Text fontSize={fontSize} color={color} lineHeight="tall">
      {showPaymentHint
        ? 'Questo riepilogo ti mostra la situazione corretta e ti permette di completare i pagamenti settimana per settimana, in modo chiaro.'
        : 'Nel riepilogo «Pagamenti da completare» trovi la situazione corretta e puoi saldare le settimane mancanti.'}
    </Text>
    <Text fontSize={fontSize} color={color} lineHeight="tall">
      Ci scusiamo per il disagio.
    </Text>
    <Text fontSize={fontSize} color={color} lineHeight="tall">
      Se sei certo di aver pagato, chiedi pure a Dario all&apos;entrata o
      all&apos;uscita del Centro Estivo e verificate insieme. Se hai dubbi,
      controlla l&apos;estratto conto o chiedici conferma.
    </Text>
  </VStack>
);

export default CheckoutBugNoticeText;
